import { computed, ref } from 'vue';
import useAuctionAccess from './useAuctionAccess';
import useAcvFeatureFlags from './useAcvFeatureFlags';
import useAcvStore from './useAcvStore';
import useAcvRoute from './useAcvRoute';

const defaultUseAcvAnnouncementsOptions = {
  configuredLanes: [],
};

const useAcvAnnouncements = (options = defaultUseAcvAnnouncementsOptions) => {
  const store = useAcvStore();
  const acvFeatureFlags = useAcvFeatureFlags();
  const { isOnMarketplace } = useAcvRoute();
  const configuredLanes = ref(options.configuredLanes || []);
  const { hasAuctionAccessIssues } = useAuctionAccess();

  const canShowEulaReviewBanner = () => {
    const isLaneEulaAcceptanceRequired = acvFeatureFlags.getFlag(
      'requireEulaAcceptanceForLanes',
    );

    if (!isLaneEulaAcceptanceRequired.value) {
      return false;
    }

    const eulaReviewBannerVisible = computed(
      () => store.getters['marketplaceView/eulaReviewBannerVisible'],
    );

    const notAcceptedLanes = configuredLanes.value.filter(
      (lane) => lane.eulaAccepted === false,
    );

    return (
      isOnMarketplace.value
      && notAcceptedLanes.length > 0
      && eulaReviewBannerVisible.value
    );
  };

  const updateAnnouncement = (announcement) => {
    store.dispatch('announcements/updateAnnouncement', announcement);
  };

  const removeAnnouncementByKey = (key) => {
    store.dispatch('announcements/removeAnnouncementByKey', key);
  };

  const resetAnnouncements = () => {
    store.dispatch('announcements/resetAnnouncements');
  };

  const initializeAnnouncements = () => {
    if (canShowEulaReviewBanner()) {
      updateAnnouncement({
        key: 'eula-review-banner',
      });
    }

    if (hasAuctionAccessIssues.value) {
      updateAnnouncement({
        key: 'auction-access-banner',
      });
    }
  };

  const announcements = computed(
    () => store.state.announcements
      .announcements?.toSorted((a, b) => a.priority - b.priority) || [],
  );

  return {
    announcements,
    canShowEulaReviewBanner,
    configuredLanes,
    initializeAnnouncements,
    updateAnnouncement,
    removeAnnouncementByKey,
    resetAnnouncements,
  };
};
export default useAcvAnnouncements;
